function galleryMasonry($) {
  setTimeout(function () {
    const slickTrack = $(".slick-track");
    const slickSlides = slickTrack.find(".gallery-slider-masonry__single-slide");
    let maxHeight = 0;

    slickSlides.each(function () {
      if ($(this).hasClass("slide-half-height")) {
        const slideHeight = $(this).height();
        maxHeight = Math.max(maxHeight, slideHeight);
      }
    });

    slickSlides.each(function () {
      if ($(this).hasClass("slide-full-height")) {
        $(this).find("img").height(maxHeight);
      }
    });
  }, 100); // delay of 100 milliseconds
}

// GLOBAL APP CONTROLLER
const controller = {
  init() {},
  loaded() {
    galleryMasonry(jQuery);
  },
  resized() {
    galleryMasonry(jQuery);
  },
  scrolled() {},
  keyDown() {},
  mouseUp() {},
};
export default controller;
